export let StringUtility = {
    containsUpperCaseLetter: function (string: string) {
        return /[A-Z]+/.test(string);
    },

    containsNumber: function (string: string) {
        return /[\d]+/.test(string);
    },

    containsSpecialCharacter: function (string: string) {
        return /[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]+/.test(string);
    },

    pluralize: function (string: string) {
        if (string === "" || string.endsWith("s")) {
            return string;
        }
        return `${string}s`;
    },

    toInitialCaps: function (string: string | null | undefined) {
        if (!string) {
            return "";
        }
        // only the first letter of each word is forced, so a stored acronym like "CA-6" keeps its capitals
        return string.replace(/[A-Za-z][A-Za-z']*/g, function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        });
    },

    stringNumberToDisplayCurrency: function (string: string) {
        const formatter = new Intl.NumberFormat(
            'en-US',
            {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
            }
        );
        return formatter.format(parseFloat('' + string))
    },
};
